import { isBoolean } from 'lodash';

/**
 * Standard registration systems are JSON-based and use real boolean values.
 * The express registration system is Jinja-templated and only supports
 * string values (server-rendered to the strings "True"/"False"), requiring
 * the conversion of strings to boolean values.
 */
export function parseBoolean(value: unknown): boolean {
  if (isBoolean(value)) {
    return value;
  }

  return String(value).toLowerCase() === 'true';
}
